import { render } from "./VerifyOTP.vue?vue&type=template&id=2a35afb4"
import script from "./VerifyOTP.vue?vue&type=script&lang=js"
export * from "./VerifyOTP.vue?vue&type=script&lang=js"

import exportComponent from "/Users/teguhsangra/Web/GSD/xsport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__